export default __webpack_public_path__ + "assets/img/img-icon-arrow-right-small.7058f4420c4b199ac882587b65cf81fa.svg";